module.exports = __webpack_public_path__ + "img/studio-7-bk.d926aaf4.svg";